<template>
  <div class="page-margin-20-40 page-bank-detail">
    <v-container fluid class="pt-0">
      <v-row class="mt-0 pt-0">
        <v-col cols="12" md="11" class="p-0">
          <h2 class="text-h6 mb-1">Bank Details</h2>
        </v-col>

        <v-col cols="12" md="1" class="p-0 ps-2 text-end">
          <v-btn v-if="bankdetails < 1" color="secondary" small class="text-none w-100 btn-32-text-12" style="color: #1976d2; font-weight: bold; background-color: white !important; 
              border: 1px solid #1976d2 !important;" @click="openDialog">
            Add Bank
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row class="mt-0">
      <v-col cols="12">
        <v-card elevation="5">
          <v-data-table :headers="bankdetailsHeaders" :items="bankdetails" :search="ssearch" :items-per-page="-1" hide-default-footer>
            <template v-slot:top>
              <v-row dense class="mx-1 pb-1">
                <v-text-field v-model="ssearch" class="m-2" clearable dense outlined hide-details
                  prepend-inner-icon="mdi-magnify mb-2" placeholder="Search Bank Details" />
              </v-row>
            </template>
            <template #item.company_name="{ item }">
              <span>{{ item.company_name }}</span>
            </template>
            <template #item.bank_name="{ item }">
              <span>{{ item.bank_name }}</span>
            </template>
            <template #item.code="{ item }">
              <span>{{ item.account_number }}</span>
            </template>
            <template #item.sort_code="{ item }">
              <span>{{ item.sort_code }}</span>
            </template>
            <template #item.is_active="{ item }">
              <v-switch v-model="item.is_active" :input-value="item.is_active === 1" @change="toggleStatus(item)" dense
                inset style="transform: scale(0.75);"></v-switch>
            </template>
            <template #header.actions1>
              <div class="text-center">Action</div>
            </template>
            <template #item.actions1="{ item }">
              <div class="text-center">
                <v-chip color="primary" class="white--text" outlined pill small @click="editItem(item)"
                  style="cursor: pointer;">
                  <v-icon small left>mdi-pencil</v-icon>Edit
                </v-chip>
              </div>
            </template>
            <template #header.actions2>
              <div class="text-center">Action</div>
            </template>
            <template #item.actions2="{ item }">
              <div class="text-center">
                <v-chip color="red" class="white--text" outlined pill small @click="confirmDelete(item)"
                  style="cursor: pointer;">
                  <v-icon small left>mdi-delete</v-icon>Delete
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="addSdialog" max-width="600" @update:model-value="onDialogToggle">
      <v-card elevation="5">
        <v-card-title>
          <span>{{ editedIndex === -1 ? 'Add Bank Detail' : 'Edit Bank Detail' }}</span>
          <v-spacer></v-spacer>
          <v-icon @click="addSdialog = false">mdi-close</v-icon>
        </v-card-title>
        <v-form v-model="fsvalid" @submit.prevent="saveBankDetail">
          <v-card-text>
            <v-text-field v-model="defaultItem.company_name"
              @input="defaultItem.company_name = defaultItem.company_name.toUpperCase()" :rules="companynameRules"
              label="Company Name" />
            <v-text-field v-model="defaultItem.bank_name"
              @input="defaultItem.bank_name = defaultItem.bank_name.toUpperCase()" :rules="banknameRules"
              label="Bank Name" />
            <v-text-field v-model="defaultItem.account_number" :rules="accountnumberRules" label="Account Number" />
            <v-text-field v-model="defaultItem.sort_code" :rules="sortcodeRules" label="Sort Code" />
            <v-text-field v-model="defaultItem.note" :rules="noteRules" label="Note" />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="btn-32-text-12" type="submit"
              style="font-weight: bold; color: #1976d2; background-color: white !important; border: 1px solid #1976d2 !important;"
              small :disabled="!fsvalid || submitting">
              {{ editedIndex === -1 ? 'Add' : 'Update' }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card elevation="5">
        <v-card-title class="text-h6">
          Confirm Delete
        </v-card-title>
        <v-card-text>
          Are you sure you want to delete this Bank Detail?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-32-text-12" text color="grey" @click="deleteDialog = false">Cancel</v-btn>
          <v-btn class="btn-32-text-12" text color="red" :loading="deleteLoading" :disabled="deleteLoading"
            @click="performDelete">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row class="mt-8">
      <v-col cols="12">
        <h2 class="text-h6 mb-1">Stripe Integrations</h2>
      </v-col>
    </v-row>

    <v-row class="mt-0">
      <v-col cols="12">
        <v-card elevation="5">
          <v-data-table :headers="stripeHeaders" :items="stripeData" :items-per-page="-1" hide-default-footer>
            <template #item.publishable_key="{ item }">
              <div class="wrap-text">{{ item.publishable_key }}</div>
            </template>
            <template #item.secret_key="{ item }">
              <div class="wrap-text">{{ item.secret_key }}</div>
            </template>
            <template #item.test_mode="{ item }">
              <v-switch v-model="item.test_mode" :input-value="item.test_mode === 1" @change="stripeTestModeStatus(item)"
                dense inset style="transform: scale(0.75);"></v-switch>
            </template>
            <!-- <template #item.webhook_secret="{ item }">
              <div class="wrap-text">{{ item.webhook_secret }}</div>
            </template> -->
            <template #item.note="{ item }">
              <div class="wrap-text">{{ item.note }}</div>
            </template>
            <template #item.is_active="{ item }">
              <v-switch v-model="item.is_active" :input-value="item.is_active === 1" @change="stripeToggleStatus(item)"
                dense inset style="transform: scale(0.75);"></v-switch>
            </template>
            <template #header.actions>
              <div class="text-center">Action</div>
            </template>
            <template #item.actions="{ item }">
              <div class="text-center">
                <v-chip color="primary" class="white--text" outlined pill small @click="openStripeEdit(item)"
                  style="cursor:pointer;">
                  <v-icon small left>mdi-pencil</v-icon>Edit
                </v-chip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="stripeDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span>Edit Stripe Integration</span>
          <v-spacer></v-spacer>
          <v-icon @click="closeStripeDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form v-model="stripeFormValid">
            <v-text-field v-model="stripeForm.publishable_key" label="Publishable Key" outlined dense
              :rules="[required]" />
            <v-text-field v-model="stripeForm.secret_key" label="Secret Key" outlined dense :rules="[required]" />
            <v-text-field v-model="stripeForm.webhook_secret" label="Webhook Secret" outlined dense />
            <v-text-field v-model="stripeForm.note" label="Notes" outlined dense />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="btn-32-text-12"
            style="font-weight: bold; color: #1976d2; background-color: white !important; border: 1px solid #1976d2 !important;"
            :disabled="!stripeFormValid || savingStripe" @click="saveStripe">
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BankDetail',
  data() {
    return {
      ssearch: '',
      bankdetails: [],
      bankdetailsHeaders: [
        { text: 'Company Name', value: 'company_name' },
        { text: 'Bank Name', value: 'bank_name' },
        { text: 'Account No', value: 'account_number' },
        { text: 'Sort Code', value: 'sort_code' },
        { text: 'Status', value: 'is_active' },
        { text: 'Action', value: 'actions1', sortable: false },
        { text: 'Action', value: 'actions2', sortable: false },
      ],

      addSdialog: false,
      editedIndex: -1,
      fsvalid: false,
      submitting: false,

      defaultItem: {
        bank_detail_id: null,
        company_name: '',
        bank_name: '',
        account_number: '',
        sort_code: '',
        note: '',
      },
      companynameRules: [
        v => !!v || 'Company Name is required',
        v => (v && v.length <= 255) || 'Company Name must be less than 255 characters',
      ],
      banknameRules: [
        v => !!v || 'Bank Name is required',
        v => (v && v.length <= 255) || 'Bank Name must be less than 255 characters',
      ],
      accountnumberRules: [
        v => !!v || 'Account Number is required',
        v => (v && v.length <= 255) || 'Account Number must be less than 255 characters',
      ],
      sortcodeRules: [
        v => !!v || 'Sort Code is required',
        v => (v && v.length <= 255) || 'Sort Code must be less than 255 characters',
      ],
      noteRules: [
        v => !!v || 'Note is required',
        v => (v && v.length <= 255) || 'Note must be less than 255 characters',
      ],
      deleteDialog: false,
      bankdetailToDelete: null,
      deleteLoading: false,

      stripeData: [],
      stripeHeaders: [
        { text: 'Publishable Key', value: 'publishable_key', sortable: false },
        { text: 'Secret Key', value: 'secret_key', sortable: false },
        { text: 'Test Mode', value: 'test_mode', sortable: false },
        // { text: 'Webhook Secret', value: 'webhook_secret', sortable: false },
        { text: 'Notes', value: 'note', sortable: false },
        { text: 'Status', value: 'is_active', sortable: false },
        { text: 'Action', value: 'actions', sortable: false },
      ],
      stripeDialog: false,
      stripeFormValid: false,
      savingStripe: false,
      stripeForm: {
        stripe_integration_id: null,
        publishable_key: null,
        secret_key: null,
        webhook_secret: null,
        note: null,
      },
    }
  },
  mounted() {
    this.fetchStripe();
  },
  created() {
    this.getAllbankdetails()
  },
  watch: {
    addSdialog(val) {
      if (!val) this.submitting = false
    },
  },

  methods: {
    getAllbankdetails() {
      axios.get('/admin/bank-detail/vlist').then(res => {
        this.bankdetails = res.data.bankdetails;
      })
        .catch(err => {
          console.error(err)
        })
    },
    onDialogToggle(open) {
      if (!open) {
        this.defaultItem =
        {
          bank_detail_id: null,
          company_name: '',
          bank_name: '',
          account_number: '',
          sort_code: '',
          note: '',
        };
        this.fsvalid = false;
        this.submitting = false;
        this.editedIndex = -1;
      }
    },
    openDialog() {
      this.defaultItem = {
        bank_detail_id: null,
        company_name: '',
        bank_name: '',
        account_number: '',
        sort_code: '',
        note: '',
      }
      this.editedIndex = -1
      this.fsvalid = false
      this.addSdialog = true
    },
    editItem(item) {
      this.defaultItem = {
        bank_detail_id: item.bank_detail_id,
        company_name: item.company_name,
        bank_name: item.bank_name,
        account_number: item.account_number,
        sort_code: item.sort_code,
        note: item.note,
      }
      this.editedIndex = item.bank_detail_id
      this.fsvalid = true
      this.addSdialog = true
    },
    async saveBankDetail() {
      this.submitting = true;

      let expiresAtValue = this.defaultItem.expires_at;

      if (expiresAtValue) {
        expiresAtValue = `${expiresAtValue} 00:00:00`;
      } else {
        expiresAtValue = null;
      }

      const payload = {
        company_name: this.defaultItem.company_name.toUpperCase(),
        bank_name: this.defaultItem.bank_name.toUpperCase(),
        account_number: this.defaultItem.account_number,
        sort_code: this.defaultItem.sort_code,
        note: this.defaultItem.note,
      };

      if (this.editedIndex !== -1) {
        payload.bank_detail_id = this.editedIndex;
      }

      const url = this.editedIndex === -1 ? '/admin/bank-detail/add' : '/admin/bank-detail/update';

      try {
        await axios.post(url, payload, {
          headers: { 'Content-Type': 'application/json' }
        });
        this.$toast.success(
          this.editedIndex === -1 ? 'Bank Detail added successfully!' : 'Bank Detail updated successfully!',
          { timeout: 500 }
        );
        this.getAllbankdetails();
        this.addSdialog = false;
      } catch (error) {
      } finally {
        this.submitting = false;
      }
    },
    async toggleStatus(item) {
      try {
        const res = await axios.post(`/admin/bank-detail/status-toggle/${item.bank_detail_id}`, {
          is_active: item.is_active
        });
        this.getAllbankdetails();
        this.fetchStripe();
        this.$toast?.success(`${res.data.message}`, { timeout: 500 });
      } catch (error) {
        console.error("Failed to toggle status", error);
        this.$toast?.error('Failed to update status', { timeout: 500 });
      }
    },
    confirmDelete(item) {
      this.bankdetailToDelete = item
      this.deleteDialog = true
    },
    async performDelete() {
      if (!this.bankdetailToDelete) return
      this.deleteLoading = true
      try {
        await axios.post('/admin/bank-detail-delete', { bank_detail_id: this.bankdetailToDelete.bank_detail_id })
        this.$toast.success('Bank Detail deleted successfully!', { timeout: 500 })
        this.getAllbankdetails();
        this.fetchStripe();
      } catch (err) {
        console.error(err)
        this.$toast.error('Failed to delete Bank Detail.', { timeout: 800 })
      } finally {
        this.deleteLoading = false
        this.deleteDialog = false
        this.bankdetailToDelete = null
      }
    },
    async fetchStripe() {
      const res = await axios.get("/admin/stripe-integration/vlist");
      if (res.data.status) {
        this.stripeData = res.data.stripe;
      }
    },
    openStripeEdit(item) {
      this.stripeForm = { ...item };
      this.stripeDialog = true;
    },
    closeStripeDialog() {
      this.stripeDialog = false;
    },
    async saveStripe() {
      this.savingStripe = true;
      try {
        await axios.post("/admin/stripe-integration/update", this.stripeForm);
        this.$toast.success("Stripe updated successfully");
        this.stripeDialog = false;
        this.fetchStripe();
      } catch (error) {
        this.$toast.error("Failed to update Stripe");
      } finally {
        this.savingStripe = false;
      }
    },
    async stripeToggleStatus(item) {
      try {
        const res = await axios.post(`/admin/stripe-integration/status-toggle/${item.stripe_integration_id}`, {
          is_active: item.is_active
        });
        this.fetchStripe();
        this.getAllbankdetails();
        this.$toast?.success(res.data.message, { timeout: 800 });
      } catch (error) {
        console.error("Failed to toggle status", error);
        this.$toast?.error('Failed to update status', { timeout: 800 });
      }
    },
    async stripeTestModeStatus(item) {
      try {
        await axios.post(`/admin/stripe-integration/test-mode-toggle/${item.stripe_integration_id}`, {
          test_mode: item.test_mode
        });
        this.fetchStripe();
        this.$toast?.success('Test mode status updated.', { timeout: 800 });
      } catch (error) {
        console.error("Failed to toggle status", error);
        this.$toast?.error('Failed to update status', { timeout: 800 });
      }
    },
    required(v) {
      return !!v || "This field is required";
    },
  },

}

</script>

<style scoped>
.v-input {
  font-size: 12px !important;
}

.wrap-text {
  white-space: normal !important;
  word-break: break-all;
  max-width: 250px;
}

.v-data-table__wrapper {
  overflow-x: hidden !important;
}
</style>
<style>
.page-bank-detail .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  height: 32px !important;
}

.page-bank-detail .v-input--radio-group__input label {
  padding-bottom: 0 !important;
}

</style>